import React from 'react';
import ReactDOM from 'react-dom/client';
import '@hamajima/annualpass/styles/index.css';
import '@hamajima/annualpass/i18n';
import App from '@hamajima/annualpass/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
